// extracted by mini-css-extract-plugin
export var actions = "_mk-5";
export var assistantBubble = "_mk-3";
export var assistantRow = "_mk-6";
export var bubble = "_mk-0";
export var humanAvatar = "_mk-4";
export var inlineToolCard = "_mk-1";
export var userBubble = "_mk-2";